import { render, staticRenderFns } from "./EverythingIsTBArticle.vue?vue&type=template&id=063767ed&"
import script from "./EverythingIsTBArticle.vue?vue&type=script&lang=js&"
export * from "./EverythingIsTBArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports